exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.input-box-wrapper[data-v-7f814dda] {\n  position: relative;\n}\n.fake-input-wrapper[data-v-7f814dda] {\n  position: absolute;\n}\n", ""]);

